'use client';

import { useTranslations } from 'next-intl';
import { MyEquipmentLoader } from '../my-equipment/my-equipment-loader';
import SideMenuLoader from '../panel-wrapper/side-panel/side-menu-loader';
import { ProductCardGridLoader } from '../../product-card/product-card-loader';
import { ServiceInsightSkeletonLoader } from '../service-Insight/service-insight-card/service-insight-loader';
import styles from '../customer-account.module.scss';

const SectionLoader = () => {
  const t = useTranslations();
  return (
    <>
      <div className="d-none d-blg-block">
        <div className="d-flex mt-4 gap-4">
          <div className={`${styles['side-menu-loader-wrapper']}`}>
            <SideMenuLoader />
          </div>
          <div className={styles['main-menu-loader-wrapper']}>
            <MyEquipmentLoader />
          </div>
        </div>
      </div>
      <div className="d-blg-none">
        <MyEquipmentLoader />
        <ProductCardGridLoader title={t('RECENTLY_VIEWED')} />
        <ServiceInsightSkeletonLoader />
        <ProductCardGridLoader title={t('HOMEPAGE_BUY_AGAIN')} />;
      </div>
    </>
  );
};

export default SectionLoader;
